import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios from '../../axios/useAxios';
import { useSelector } from 'react-redux';
import mailLogo from '../../styles/img/mail.svg';
import logoGoogle from '../../styles/img/google.svg';
import tel from '../../styles/img/tel.svg';
import fid_card from '../../styles/img/fid_card.svg';
import BackButton from '../../components/button/BackButton.jsx';
import Email from './login/Email.jsx';
import { isAppPWA } from '../../utils/helper-functions.js';
import Lottie from 'lottie-react';
import { useTheme } from 'styled-components';
import { LottieLogo } from '../../utils/LottieLogo.jsx';
import { FooterAccount } from '../../components/footerAccount.jsx';
import { useFunnelTracking } from '../../posthog/funnelTracking';
import { usePerformanceContext } from '../../context/PerformanceContext.jsx';
import { useGoogleAuth } from '../../context/GoogleAuthContext';
import {
  ACCOUNT, HOME,
  INVITATION,
  NUMBER_SCREEN,
  PROMO,
  REGISTER,
  SCAN,
  SET_ACCOUNT,
} from '../../constants/routes';

const LoginScreen = () => {
  const { prevPage, numberSreenPrevPage } = useLocation().state || '';
  const resetEmail = useLocation().state?.resetEmail;
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);
  const { isLoadingGoogleAuth, initiateGoogleLogin } = useGoogleAuth();
  const [fidCompany, setFidCompany] = useState(false);
  const [fidExist, setFidExist] = useState(false);
  const [previousNumberScreen, setPreviousNumberScreen] = useState(null);
  const refComposant = useRef();
  const theme = useTheme();
  const { markComplete } = usePerformanceContext();
  const isPWA = isAppPWA();
  const { trackPageViewAccount } = useFunnelTracking();
  const [selectedItem, setSelectedItem] = useState(4);
  const axiosInstance = useAxios();

  useEffect(() => {
    trackPageViewAccount({
      isLoggedIn: false,
    });
  }, [trackPageViewAccount]);

  useEffect(() => {
    if (user?._id) {
      if (isPWA && !user.favoriteStore) {
        navigate(SET_ACCOUNT);
      } else {
        console.info('LoginScreen redirecting to ACCOUNT', user);
        navigate(ACCOUNT);
      }
    }
  }, [user, isPWA, navigate]);


  useEffect(() => {
    window.scrollTo(0, 0);
    if (numberSreenPrevPage && numberSreenPrevPage === INVITATION) {
      setPreviousNumberScreen(numberSreenPrevPage);
    }
  }, [numberSreenPrevPage]);

  useEffect(() => {
    if (user?.id) {
      if (prevPage === 'invitation') {
        navigate(PROMO, { state: { prevPage: 'account' } });
        localStorage.removeItem('popupUser');
      } else if (prevPage === SCAN) {
        navigate(SCAN);
      }
    }
  }, [user, prevPage, navigate]);

  useEffect(() => {
    if (!isLoadingGoogleAuth) {
      markComplete();
    }
  }, [isLoadingGoogleAuth, markComplete]);

  const navigateToRegister = () => {
    navigate(REGISTER);
  };

  const CheckIfFidExist = () => {
    if (fidExist) {
      setFidCompany(!fidCompany);
    }
  };

  const goBack = () => {
    if (previousNumberScreen === INVITATION) {
      navigate(NUMBER_SCREEN, { state: { prevPage: INVITATION } });
    } else {
      navigate(HOME);
    }
  };

  return (
    <>
      <div
        id="page_login"
        className="w-full h-full overflow-y-scroll"
      >
        <div className="page_account_body pt-10 pb-10 height_normal bg-gradient3">
          <BackButton onClick={goBack} isWhite={false} />
          <div className="header-svg-container">
            <div>
              <span className="header-connect">
                Hello
                <Lottie
                  loop={LottieLogo[theme?.name]?.loop ?? false}
                  animationData={LottieLogo[theme?.name]?.image}
                  className={`
                    ${theme?.name === 'default' ? 'w-[50px] translate-y-4 transform' : 'w-[50px]'}
                  `}
                />
              </span>
              <span className="description-connect">
                connecte-toi à ton compte
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={navigateToRegister}
            className="sticky w-full my-4 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            Pas encore de compte ?{' '}
            <strong className="bold_blue ">Créer un compte !</strong>
          </button>

          <div className="flex flex-col items-start justify-start w-screen h-full p-6 ">
            <div className="flex flex-col items-center justify-start w-full py-6 gap-14">
              <div className="flex items-center justify-center gap-8 space-x-4">
                <button type="button" onClick={CheckIfFidExist} className="border-none">
                  {fidCompany ? (
                    <img
                      className="h-[50px] w-auto"
                      src={mailLogo}
                      alt="google"
                    />
                  ) : (
                    <img
                      className="h-[50px] w-auto "
                      src={fid_card}
                      alt="fid"
                    />
                  )}
                </button>
                <button
                  type="button"
                  className="flex items-center justify-center w-full gap-4 text-3xl font-black flex-nowrap border-none"
                  onClick={() => navigate(NUMBER_SCREEN)}
                >
                  <img src={tel} alt="telephone" />
                </button>
                <button type="button" onClick={initiateGoogleLogin} className="border-none">
                  <img
                    className="h-[50px] w-auto"
                    src={logoGoogle}
                    alt="google"
                  />
                </button>
              </div>
            </div>
            <Email
              user={user}
              cartItems={cartItems}
              ref={refComposant}
              resetEmail={resetEmail}
              axiosInstance={axiosInstance}
              fidCompany={fidCompany}
              setFidCompany={setFidCompany}
              fidExist={fidExist}
              setFidExist={setFidExist}
            />
          </div>
        </div>
      </div>
      <FooterAccount
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default LoginScreen;

